import { render, staticRenderFns } from "./menubar.vue?vue&type=template&id=52c0204a&"
import script from "./menubar.vue?vue&type=script&lang=js&"
export * from "./menubar.vue?vue&type=script&lang=js&"
import style0 from "./menubar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports